import React from 'react';
import PropTypes from 'prop-types';
import { Input, Select, Button } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import { generateOptions } from '../../../shared/selectFn';
import { Position, WorkStatus, Default } from '../constants';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';

const { Option } = Select;
const PositionOption = generateOptions(Position);
const WorkStatusOption = generateOptions(WorkStatus);
const DefaultOption = generateOptions(Default);

export default function Filter(props, context) {
    const { current, position, leaveReason, searchParams, changeCurrent, onSearch, onExport, onChange, positionNameList, isAdditionalUser, additionalUserExport } = props;
    const { situation } = context;
    
    const handleChange = (value, key) => {
        switch (key) {
            case 'leader':
            case 'teacher': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                break;
            }
            default: {
                searchParams[key] = value;
                break;
            }
        }
        onChange(searchParams);
    };

    const leaveReasonOption = leaveReason.map(i => <Option key={i.userLeaveReasonId}>{i.reason}</Option>);
    const situationOption = situation.map(i => <Option key={i.code}>{i.name}</Option>);
    const positionNameOption = positionNameList.map(i => <Option key={i}>{i}</Option>);
    const canExport = isAdditionalUser ? additionalUserExport : true;
    return (
        <div className="search-bar" style={{ marginBottom: 16 }}>
           <div className="search-item">
                <label className="ui-label">工号</label>
                <Input
                    placeholder="请输入"
                    style={{width: 100}}
                    value={searchParams.employeeCode}
                    onChange={e => handleChange(e.target.value, 'employeeCode')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">姓名</label>
                <Input
                    placeholder="请输入"
                    style={{width: 100}}
                    value={searchParams.userCompellation}
                    onChange={e => handleChange(e.target.value, 'userCompellation')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">职位级别</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 130}}
                    value={format('toString', searchParams.positionName)}
                    onChange={value => handleChange(value, 'positionName')}
                >
                    { !current ? positionNameOption : position.map(i => <Option key={i} title={i}>{i}</Option>) }
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">主管领导</label>
                <SearchRetrieve
                    keyword='keyword'
                    style={{ width: 130 }}
                    params={{ limit: 20 }}
                    placeholder="输入姓名/工号检索"
                    value={searchParams.leaderName}
                    url={API_URL.investigation.queryUserByKey}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={option => handleChange(option, 'leader')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">工作城市</label>
                <Input
                    placeholder="请输入"
                    style={{width: 80}}
                    value={searchParams.workCity}
                    onChange={e => handleChange(e.target.value, 'workCity')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">状态</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 80}}
                    value={format('toString', searchParams.workStatus)}
                    onChange={value => handleChange(value, 'workStatus')}
                >
                    {WorkStatusOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">离职原因</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 100}}
                    value={format('toString', searchParams.firstReasonId)}
                    onChange={value => handleChange(value, 'firstReasonId')}
                >
                    {leaveReasonOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">带教老师</label>
                <SearchRetrieve
                    keyword='keyWord'
                    style={{ width: 140 }}
                    params={{ limit: 20, roleCodes: 'CRC,CRCC,CRCM', workStatus: 'ALL', requireNaTeacher: 1 }}
                    placeholder="输入姓名/工号检索"
                    value={searchParams.teacherName}
                    url={API_URL.teaching.queryEmpListByRoleCode}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={option => handleChange(option, 'teacher')}
                />
            </div>
            <div className="search-item">
                <label className="ui-label">是否到达第一阶段评估时间</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 80}}
                    value={format('toString', searchParams.isArriveFirstEvaluate)}
                    onChange={value => handleChange(value, 'isArriveFirstEvaluate')}
                >
                    {DefaultOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">是否到达第二阶段评估时间</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 80}}
                    value={format('toString', searchParams.isArriveSecondEvaluate)}
                    onChange={value => handleChange(value, 'isArriveSecondEvaluate')}
                >
                    {DefaultOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">是否到达新人独立承接项目评估时间</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 80}}
                    value={format('toString', searchParams.isNewIndependent)}
                    onChange={value => handleChange(value, 'isNewIndependent')}
                >
                    {DefaultOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">带教奖上报</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 120}}
                    value={format('toString', searchParams.reportInfo1)}
                    onChange={value => handleChange(value, 'reportInfo1')}
                >
                    {situationOption}
                </Select>
            </div>
            <div className="search-item">
                <label className="ui-label">出师奖上报</label>
                <Select
                    allowClear={true}
                    placeholder="请选择"
                    style={{width: 120}}
                    value={format('toString', searchParams.reportInfo2)}
                    onChange={value => handleChange(value, 'reportInfo2')}
                >
                    {situationOption}
                </Select>
            </div>
            <div className="search-item">
                <Button type="primary" onClick={onSearch}>搜索</Button>
                { (!current && canExport) && <Button type="primary" onClick={onExport}>导出</Button> }
                {
                    !current ?
                        <Button className="btn-green" onClick={() => changeCurrent(1)}>已晋升人员</Button>
                    :
                        <Button className="btn-green" onClick={() => changeCurrent(0)}>返回</Button>
                }
            </div>
        </div>
    );
}

Filter.contextTypes = {
    situation: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/teachingManagement/management/components/Filter.js